import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { ModuleManager } from 'src/shared/models/module-manager';

@Component({
  selector: 'cv-agent-state-summary-settings',
  templateUrl: './agent-state-summary-settings.component.html',
  styleUrl: './agent-state-summary-settings.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class AgentStateSummarySettingsComponent implements OnInit {
  @Input() moduleManager: ModuleManager;
  public onlyUnavailable = false;

  constructor(private cvLocalizationService: CVLocalizationService) { }

  ngOnInit(): void {
      this.moduleManager.addSetting({
          name: 'onlyUnavailable',
          required: true,
          getValue: () => this.onlyUnavailable,
          onSettingLoaded: value => {
              this.onlyUnavailable = value !== undefined ? value : false;
          },
      });

      this.moduleManager.customSettingsAdded = true;
  }

  getLocalizationString(key, defaultValue): string {
      const baseString = this.cvLocalizationService.getCachedText("CXOne_Modal", key, defaultValue);
      return baseString;
  }
}
